import axios, { AxiosPromise } from 'axios';
import { IGetSettledSemesterCourses, IGetSettledSemesterCoursesParams } from '../models/semesterCourses.model';

const uri = '/mgmt/semester-courses';

export const getSettledSemesterCourses = (params: IGetSettledSemesterCoursesParams): AxiosPromise<IGetSettledSemesterCourses> => {
  return axios.get(uri, { params });
};
